export default class Note {
    constructor(data = {}) {
      this.id = data.id || null;
      this.invoiceId = data.invoiceId || null;
      this.content = data.content || null;
      this.subjectCode = data.subjectCode || null;
    }
  
    toJSON() {
      console.log('Serializing Note:', this);
      return {
        id: this.id,
        invoiceId: this.invoiceId,
        content: this.content,
        subjectCode: this.subjectCode
      };
    }
  }
  